// extracted by mini-css-extract-plugin
export var aiStarIcon = "_jz-2";
export var container = "_jz-4";
export var dismissButton = "_jz-3";
export var hasPaddingBottom = "_jz-6";
export var last = "_jz-e";
export var scrollbarThumb = "_jz-c";
export var scrollbarTrack = "_jz-b";
export var selected = "_jz-9";
export var spin = "_jz-1";
export var spinning = "_jz-0";
export var suggestionItem = "_jz-d";
export var suggestionsPanel = "_jz-5";
export var tonePill = "_jz-8";
export var tonesContainer = "_jz-7";
export var unselected = "_jz-a";